import * as Icons from "lucide-react";

// Renders a lucide icon by string name (from content model).
export const Icon = ({ name, className = "h-5 w-5", ...props }) => {
  const Cmp = Icons[name] || Icons.Circle;
  return <Cmp className={className} {...props} />;
};
